import React from 'react'
import PropTypes from 'prop-types'
import TrackListRow from './TrackListRow'
import MetadataTrackRow from './MetadataTrackRow'

export default function Track({
  track = {},
  index = 0,
  isCanadianContent = false,
  metaData,
  showMetadata = false,
  isExpanded = false
}) {
  if (metaData) {
    return (
      <MetadataTrackRow
        index={index}
        isExpanded={isExpanded}
        track={track} />
    )
  }

  return (
    <TrackListRow
      index={index}
      isCanadianContent={isCanadianContent}
      showMetadata={showMetadata}
      isExpanded={isExpanded}
      track={track} />
  )
}

Track.propTypes = {
  track: PropTypes.shape({}),
  index: PropTypes.number,
  isCanadianContent: PropTypes.bool,
  metaData: PropTypes.bool,
  showMetadata: PropTypes.bool,
  isExpanded: PropTypes.bool
}
